import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";

const ThemeContext = createContext();
export const useTheme = () => useContext(ThemeContext);

const systemTheme = () =>
  window.matchMedia && window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => localStorage.getItem("pp_theme") || "dark"); // light | dark | system
  const [resolved, setResolved] = useState(() => {
    const m = localStorage.getItem("pp_theme") || "dark";
    return m === "system" ? systemTheme() : m;
  });

  useEffect(() => {
    const apply = () => {
      const r = mode === "system" ? systemTheme() : mode;
      setResolved(r);
      document.documentElement.setAttribute("data-theme", r);
    };
    apply();
    localStorage.setItem("pp_theme", mode);
    if (mode === "system" && window.matchMedia) {
      const mq = window.matchMedia("(prefers-color-scheme: light)");
      mq.addEventListener("change", apply);
      return () => mq.removeEventListener("change", apply);
    }
  }, [mode]);

  // Applique une préférence reçue du serveur (sans la re-persister côté serveur)
  const applyServerTheme = useCallback((m) => {
    if (m && ["light", "dark", "system"].includes(m)) setMode(m);
  }, []);

  const toggle = useCallback(() => setMode(() => (resolved === "dark" ? "light" : "dark")), [resolved]);

  const value = useMemo(() => ({ mode, theme: resolved, setMode, applyServerTheme, toggle }),
    [mode, resolved, applyServerTheme, toggle]);

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}
